var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 13.4464L8.62678 11.4732C8.39198 11.2384 8.09286 11.125 7.75 11.125C7.40714 11.125 7.10802 11.2384 6.87322 11.4732C6.63842 11.708 6.525 12.0071 6.525 12.35C6.525 12.6929 6.63842 12.992 6.87322 13.2268L9.72322 16.0768C9.96695 16.3205 10.2627 16.45 10.6 16.45C10.9373 16.45 11.233 16.3205 11.4768 16.0768L17.1268 10.4268C17.3616 10.192 17.475 9.89287 17.475 9.55C17.475 9.20714 17.3616 8.90802 17.1268 8.67322C16.892 8.43843 16.5929 8.325 16.25 8.325C15.9071 8.325 15.608 8.43843 15.3732 8.67322L10.6 13.4464ZM12 21.75C10.6492 21.75 9.38306 21.4939 8.19905 20.983C7.01018 20.47 5.97852 19.775 5.10178 18.8982C4.22503 18.0215 3.53005 16.9898 3.01704 15.801C2.50613 14.6169 2.25 13.3508 2.25 12C2.25 10.6492 2.50613 9.38306 3.01704 8.19905C3.53005 7.01018 4.22503 5.97852 5.10178 5.10178C5.97852 4.22503 7.01018 3.53005 8.19905 3.01704C9.38306 2.50613 10.6492 2.25 12 2.25C13.3508 2.25 14.6169 2.50613 15.801 3.01704C16.9898 3.53005 18.0215 4.22503 18.8982 5.10178C19.775 5.97852 20.47 7.01018 20.983 8.19905C21.4939 9.38306 21.75 10.6492 21.75 12C21.75 13.3508 21.4939 14.6169 20.983 15.801C20.47 16.9898 19.775 18.0215 18.8982 18.8982C18.0215 19.775 16.9898 20.47 15.801 20.983C14.6169 21.4939 13.3508 21.75 12 21.75Z",
    fill: "white",
    stroke: "#204A22",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.731cd7d9842aea9536f1fa8e0d7465a5.svg";
export { ForwardRef as ReactComponent };